__webpack_require__.p = "/border-radius-tokens/referrals-hub/";